import { Skeleton } from "~/components/ui/skeleton";

export function HomeLoader() {
	return (
		<div className="min-h-screen bg-black text-primary-foreground">
			{/* Header */}
			<header className="sticky top-0 z-10 border-b border-primary/20 bg-black/90 backdrop-blur-xl">
				<div className="mx-auto max-w-5xl flex items-center justify-between p-4">
					{/* Logo */}
					<h1 className="text-3xl font-bold tracking-wide font-heading opacity-50">
						<span className="text-accent">m</span>
						<span className="text-primary-foreground">eteor</span>
					</h1>
				</div>
			</header>

			{/* Main Content */}
			<main className="mx-auto max-w-5xl p-4 pt-6 pb-24 md:pb-6">
				{/* Welcome Message */}
				<div className="mb-8">
					<Skeleton className="h-12 w-64 bg-accent/20 rounded mb-3" />
					<Skeleton className="h-5 w-48 bg-accent/20 rounded" />
				</div>

				{/* Tabs */}
				<div className="mb-6">
					<div className="h-10 bg-primary/10 border border-primary/20 rounded-md w-fit p-1 flex">
						<Skeleton className="h-8 w-28 rounded bg-accent/20" />
						<Skeleton className="h-8 w-24 rounded bg-transparent mx-1" />
						<Skeleton className="h-8 w-20 rounded bg-transparent" />
					</div>
				</div>

				{/* Events Grid */}
				<div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-2">
					{/* Event Cards */}
					{[1, 2].map((i) => (
						<div
							key={i}
							className="aspect-[5/3] w-full rounded-3xl bg-primary/10 border border-primary/20 overflow-hidden"
						>
							<div className="h-full relative">
								{/* Gradient background for image placeholder */}
								<div className="absolute inset-0 bg-gradient-to-br from-accent/20 via-primary/10 to-primary/20" />
								<div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/60 to-black" />

								{/* Content */}
								<div className="absolute bottom-0 p-6 w-full">
									<Skeleton className="h-8 w-4/5 bg-primary/20 rounded mb-3" />

									<div className="flex items-center gap-2 mb-2">
										<div className="w-4 h-4 rounded-full bg-primary/20" />
										<Skeleton className="h-4 w-36 bg-primary/20 rounded" />
									</div>

									<Skeleton className="h-6 w-1/3 rounded-full bg-primary/20 mb-4" />

									<div className="mt-4 flex items-center justify-between">
										<div className="flex -space-x-2">
											<div className="h-8 w-8 rounded-full border-2 border-black bg-primary/20" />
											<div className="h-8 w-8 rounded-full border-2 border-black bg-primary/20" />
										</div>
										<Skeleton className="h-6 w-24 rounded-full bg-accent/20" />
									</div>
								</div>
							</div>
						</div>
					))}
				</div>
			</main>
		</div>
	);
}
